import * as React from "react";
import styles from "./MyWayForwardSummary-CapOne.module.less";
import { FormattedMessage } from "react-intl";
const Link = () => (<a className="link" href="http://www.mywayforward.com/" target="_blank">
		www.MyWayForward.com
	</a>);
const MyWayForwardSummary = () => (<div>
		<div className="vr vr_x4">
			<h3 className="hdg">
				<FormattedMessage id="dashboard.myWayForwardSummary.heading" defaultMessage={"Find out more information about handling financial affairs for a person "
    + "who has passed away"}/>
			</h3>
		</div>
		<div className="text">
			<FormattedMessage tagName="p" id="dashboard.myWayForwardSummary.summary" defaultMessage={("The website {link} has a lot of helpful information for those dealing with "
    + "the death of a loved one. The website includes legal, financial, and "
    + "government information, plus tools and checklists to guide you through "
    + "these trying times.")} values={{
    link: <Link />
}}/>
			<p className={styles.emphasis}>
				<FormattedMessage id="dashboard.myWayForwardSummary.notice" defaultMessage={"By clicking this link, you will be leaving the Capital One site. Please be "
    + "aware that {link} is not associated with Capital One. It may have "
    + "different privacy and security practices from those offered by Capital One."} values={{
    link: <Link />
}}/>
			</p>
		</div>
	</div>);
export default MyWayForwardSummary;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/Dashboard/MyWayForwardSummary/MyWayForwardSummary-CapOne.tsx